import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { SftpImportConfigurationWorkflow, ImportType, InventoryMode, DataType, LibraryImportExistingInventoryModeType, LibraryImportNonSummaryRowsModeType, getLibraryImportExistingInventoryModeTypeDescriptions } from '../../../store/Models/Api/SftpImportModels';

interface LibraryImportInfoSectionLocalProps {
    configData: SftpImportConfigurationWorkflow;
}

type LibraryImportInfoSectionProps = LibraryImportInfoSectionLocalProps & ToxnotComponentProperties;

class LibraryImportInfoSectionComponent extends ToxnotComponent<LibraryImportInfoSectionProps> {
    public render() {
        const { configData, appServices } = this.props;
        const libraryImportDescriptions = getLibraryImportExistingInventoryModeTypeDescriptions(appServices);

        return (
            <>
                {configData.libraryImportExistingInventoryMode !== LibraryImportExistingInventoryModeType.OverwriteExisting ? (
                    <p><strong>{this.localizeString("Library Conflict Action")}:</strong> {libraryImportDescriptions[configData.libraryImportExistingInventoryMode as LibraryImportExistingInventoryModeType] || configData.libraryImportExistingInventoryMode}</p>
                ) : (
                    <>
                        <p><strong>{this.localizeString("Library Conflict Action")}:</strong> {libraryImportDescriptions[configData.libraryImportExistingInventoryMode as LibraryImportExistingInventoryModeType] || configData.libraryImportExistingInventoryMode}</p>
                        <p><strong>{this.localizeString("Update Summary Rows")}:</strong> {configData.libraryImportShouldUpdateSummaryRows ? 'yes' : 'no'}</p>
                        <p><strong>{this.localizeString("Replace Content Rows")}:</strong> {configData.libraryImportNonSummaryRowsMode === LibraryImportNonSummaryRowsModeType.ReplaceNonSummaryRows ? 'replace' : 'leave'}</p>
                    </>
                )}
            </>
        );
    }
}

export const LibraryImportInfoSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(LibraryImportInfoSectionComponent);
